const styles = (theme) => ({
  arrowIcon: {
    transform: 'rotate(90deg)',
  },
  backToTop: {
    position: 'absolute',
    bottom: 80,
    right: 20,
    zIndex: 'auto',
  },
  fab: {
    height: 50,
    width: 50,
    borderRadius: '50%',
    backgroundColor: theme.color.white,

    '&:hover': {
      backgroundColor: theme.color.white,
    },
  },
});

export default styles;
